import { createTheme } from '@mui/material/styles';
import { brand, palette as tokenPalette, typography as tokenTypography, gradients, shape as tokenShape } from './design/tokens';

/**
 * MUI theme generator aligned with Dewatanet brand palette:
 * - Primary: Vivid Red (#DC2626)
 * - Secondary: Deep Grey (#1F2937)
 * - Background (light): White (#FFFFFF)
 * - Background (dark): Solid Black (#0A0A0B)
 */
export const getMuiTheme = (mode = 'light') => {
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      primary: {
        main: brand.vividRed || '#DC2626',
        contrastText: '#FFFFFF',
      },
      secondary: {
        main: brand.deepGrey || '#1F2937',
        contrastText: '#FFFFFF',
      },
      background: {
        default: tokenPalette[mode].backgroundDefault,
        paper: tokenPalette[mode].backgroundPaper,
      },
      text: {
        primary: tokenPalette[mode].textPrimary,
        secondary: tokenPalette[mode].textSecondary,
      },
      divider: tokenPalette[mode].divider,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: tokenShape.buttonRadius,
            textTransform: 'none',
            fontWeight: tokenTypography.buttonWeightAlt,
          },
          containedPrimary: {
            boxShadow: 'none',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: tokenShape.paperRadius,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: tokenShape.chipRadius,
            fontWeight: tokenTypography.buttonWeightAlt,
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          colorPrimary: {
            backgroundImage: gradients.primary,
          },
        },
      },
    },
    typography: {
      fontFamily: tokenTypography.fontFamily,
      button: {
        fontWeight: tokenTypography.buttonWeight,
      },
    },
    shape: {
      borderRadius: tokenShape.borderRadius,
    },
  });
};
